module.exports = __webpack_public_path__ + "img/55d754aebfe4e54279486acfe801fc6b.png";